import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteVisibilityPayload {
    settingId: string
    visibilityId: string
}

export interface IDeleteVisibilityState {
    status: string
    data: any
    errors: any
}

const initialState: IDeleteVisibilityState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteVisibility = createSlice({
    name: 'setting/delete-visibility',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteVisibilityPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteVisibilityActions = deleteVisibility.actions
export default deleteVisibility.reducer
